import { getResultInfo } from 'rise-ui/utils/time-series/result.js';

export function eachApiRequest(...args) {
  const options = args.pop();
  const { getOwner, data: { apiRequest } } = options.data.root;
  let result = '';
  if (apiRequest?.loader) {
    result += options.fn(this, { blockParams: [ getResultInfo(apiRequest.loader), 0 ] });
  } else {
    const graphResults = getOwner().lookup('service:time-series/graph-results');
    graphResults.outputs?.forEach((output, i) => {
      result += options.fn(this, { blockParams: [ getResultInfo(output.loader), i ] });
    });
  }
  return result;
}
